import { GoogleMaterialIcon } from '../../../ui/GoogleMaterialIcon';
import { useEffect, useState, useContext, Fragment, useRef } from "react";
import Box from "@mui/material/Box";
import MuiButton from "@mui/material/Button";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import ListItemText from "@mui/material/ListItemText";
import Collapse from "@mui/material/Collapse";
import Input from "@mui/material/Input";
import { Stack, TextField, Typography, Tooltip } from "@mui/material";
import { Delete, Edit } from "@mui/icons-material";
import Alert from "@mui/material/Alert";
import Divider from "@mui/material/Divider";
import IconButton from "@mui/material/IconButton";
import ClientFilingMasterContext from "../../../../context/client-filing-master/ClientFilingMasterContext";
import AuthContext from "../../../../context/auth/AuthContext";
import useDialog from "../../../common/UseDialog";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import { TrackNowTextField } from '../../../ui';
import { useCommonDetailsContext } from "../../../../context/Common/common";
import { tokens } from '../../../../theme/tokens'; 
import {
  fetchClientFilingTrackerComments,
  createTrackerCommentAttachment,
  downloadTrackerCommentAttachment,
  updateTrackerComment,
  deleteCommentsAndAttachment,
  deleteCommentsOnly,
} from "./helper";
import { TrackNowButton } from '../../../ui';

const CalendarDetailsComments = () => {
  const { publishedBranding, clientScopedBranding, validateParentData } = useCommonDetailsContext();
  const activeBranding = validateParentData?.isSingleParent ? publishedBranding : (clientScopedBranding || publishedBranding);
  const primaryColor = activeBranding?.primaryColor || tokens.colors.connectedPurple;
  const [isLoading, setIsLoading] = useState(false);
  const [commentsList, setCommentsList] = useState([]);
  const [actionType, setActionType] = useState("Add");
  const [approvalComment, setApprovalComment] = useState("");
  const [remainingChars, setRemainingChars] = useState(256);
  const [openAttachment, setOpenAttachment] = useState(false);
  const [selectedComment, setSelectedComment] = useState({});
  const [selectedFile, setSelectedFile] = useState("");
  const [alertMessage, setAlertMessage] = useState("");
  const [showError, setShowError] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);
  const [expanded, setExpanded] = useState(false);


  const authContext = useContext(AuthContext);
  const { authUser, userRoles, toLocalDateTime } = authContext;
  const clientFilingMasterContext = useContext(ClientFilingMasterContext);
  const { selectedTrackerCalendarEvent, selectedTrackerCalendarEventDisplay, addClientFilingTrackerComment } =
    clientFilingMasterContext;

  const getFilenameToolip = function (str) {
    return str ? str.replace(/^.*[\\\/]/, "") : "";
  };
  const handleChange = () => {
    setExpanded((prev) => !prev);
  };
  const getUserName = (userId) => {
    const user = userRoles
      ? userRoles?.filter((user) => user.userId === parseInt(userId))[0]
        ?.userName
      : "";
    return user;
  };

  const getFilename = function (str) {
    const MAX_FILENAME_LENGTH = 20;

    if (str) {
      let filename = str.replace(/^.*[\\\/]/, "");
      if (filename.length > MAX_FILENAME_LENGTH) {
        const halfLength = Math.floor((MAX_FILENAME_LENGTH - 3) / 2);
        const firstHalf = filename.substr(0, halfLength);
        const secondHalf = filename.substr(-halfLength);
        filename = `${firstHalf}...${secondHalf}`;
      }
      return filename;
    } else {
      return "";
    }
  };

  const onFileChange = async (event) => {
    const file = event.target.files[0];
    setSelectedFile(file);
  };

  const onCommentChange = async (e) => {
    setApprovalComment((old) => e.target.value);
    if (approvalComment) {
      setShowSuccess(false);
      setShowError(false);
    }
  };

  const renderAttachment = (rowData) => {
    // console.log("renderAttachment", rowData);
    return (
      <MuiButton
        size="small"
        variant="text"
        style={{ fontSize: "0.8rem" }}
        onClick={() => downloadFile(rowData)}
      >
        <Tooltip title={getFilenameToolip(rowData.attachmentPath)}>
          {rowData.attachmentPath && getFilename(rowData.attachmentPath)}
        </Tooltip>
      </MuiButton>
    );
  };

  const handleCancel = async () => {
    setApprovalComment(() => "");
    setShowSuccess(false);
    setShowError(false);
    setRemainingChars(256);
    setSelectedComment({});
    setActionType("Add");
    formRef.current && formRef.current.reset();
  };

  const handleEditComment = (item) => {
    // console.log("handleEditComment", item , props.tracker)
    setActionType("Edit");
    setSelectedComment(item);
    setApprovalComment(item.commentsText);
  };

  const downloadFile = async (commentData) => {
    console.log("downloadFile props", commentData);
    const { filingId } = selectedTrackerCalendarEventDisplay._def.extendedProps;
    const fileName = getFilename(commentData.attachmentPath);
    await downloadTrackerCommentAttachment(commentData, filingId, fileName);
  };

  const handleAddComment = async () => {
    setIsLoading(true);
    setShowError(false);

    if (approvalComment.length === 0) {
      setAlertMessage("Please enter a comment.");
      setShowError(true);
      setIsLoading(false);
      setShowSuccess(false);
    } else {
      setShowSuccess(false);
      setShowError(false);

      try {
        const createDate = new Date();
        const { fileTrackingId, filingId, customerId } =
          selectedTrackerCalendarEventDisplay._def.extendedProps;

        let res;
        if (selectedFile !== "") {
          let payload = {
            Files: selectedFile,
            Commenttext: approvalComment,
            filingId: filingId?.toString() ?? "0",
            FileTrackingId: fileTrackingId,
            createUser: authUser?.userId + "",
          };
          res = await createTrackerCommentAttachment(payload, customerId);
        } else {
          let fileTrackingIds = [];
          fileTrackingIds.push({
            fileTrackingId: fileTrackingId,
          });
          const payload = {
            commentsText: approvalComment,
            fileTrackingIdsList: fileTrackingIds,
            createDate,
            createUser: authUser?.userId + "",
          };
          if (addClientFilingTrackerComment)
            res = await addClientFilingTrackerComment(payload);
        }
        // console.log("updateChildRecordComment res",res)

        if (res) {
          fetchCalendarEventComments();
          setAlertMessage("Comment has been added");
          setShowError(false);
          setShowSuccess(true);
          setApprovalComment(() => "");
          setSelectedFile("");
          setOpenAttachment(false);
          setSelectedComment({});
          formRef.current && formRef.current.reset();
          setRemainingChars(256);
          return;
        }
      } catch (error) {
        setAlertMessage("`Error while adding comment");
        setShowError(true);
        setApprovalComment(() => "");
        setRemainingChars(256);
      } finally {
        setIsLoading(false);
      }
    }
  };

  const editComment = async () => {
    // console.log("editComment", selectedComment , props.tracker)
    setIsLoading(true);
    try {
      const updateDate = new Date();
      let payload = [{
        commentsId: selectedComment.commentsId,
        fileTrackingId: selectedComment.fileTrackingId,
        commentsText: approvalComment,
        updateDate,
        updateUser: authUser?.userId + "",
      }];
      let res = await updateTrackerComment(payload);
      // console.log("editComment res", res)
      if (res) {
        fetchCalendarEventComments();
        setAlertMessage("Successfully updated comment.");
        setShowError(false);
        setShowSuccess(true);
        setSelectedComment({});
        formRef.current && formRef.current.reset();
        setApprovalComment("");
        setActionType("Add");
      }
    } catch (error) {
      console.log("@@Error:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleDeleteComment = (item) => {
    setActionType("Add");
    setSelectedComment(item);
    showDialog(
      "Confirmation",
      <Typography>Are you sure you want to delete this comment?</Typography>,
      "confirm"
    );
  };

  const deleteComments = async () => {
    console.log("deleteComments", selectedComment);
    setIsLoading(true);
    try {
      let res;
      if (
        selectedComment.attachmentPath &&
        selectedComment.attachmentPath !== "undefined"
      ) {
        const { filingId, customerId } =
          selectedTrackerCalendarEventDisplay._def.extendedProps;
        let payload = {
          fileTrackingId: selectedComment.fileTrackingId,
          commentsId: selectedComment.commentsId,
          attachmentId: selectedComment.attachmentId,
        };
        res = await deleteCommentsAndAttachment(payload, customerId, filingId);
      } else {
        const updateDate = new Date();
        let payload = {
          commentsId: selectedComment.commentsId,
          fileTrackingId: selectedComment.fileTrackingId,
          updateUser: authUser?.userId + "",
          updateDate,
          isDelete: true,
        };
        res = await deleteCommentsOnly(payload);
      }

      // let res = await axios.delete(url, { data: payload })
      console.log("deleteComments res", res);
      if (res) {
        fetchCalendarEventComments();
        setAlertMessage("Successfully deleted comment.");
        setShowError(false);
        setShowSuccess(true);
        closeDialog();
        setSelectedComment({});
      }
    } catch (error) {
      console.log("@@Error:", error);
    } finally {
      console.log("PROGRESS-BAR editComment ");

      setIsLoading(false);
    }
  };

  const closeConfirm = () => { };

  const fetchCalendarEventComments = async () => {
    const { fileTrackingId, customerId } =
      selectedTrackerCalendarEventDisplay._def.extendedProps;
    try {
      const res = await fetchClientFilingTrackerComments(
        fileTrackingId,
        customerId
      );
      const uniqueComments = Array.from(
        res
          .filter((item) => !('attachmentId' in item) || item.attachmentId !== 0)
          .reduce((map, item) => {
            const existingItem = map.get(item.commentsId);

            // Prioritize items with attachmentId
            if (!existingItem || ('attachmentId' in item && item.attachmentId !== 0)) {
              map.set(item.commentsId, item);
            }

            return map;
          }, new Map())
          .values()
      );
      console.log("fetchCalendarEventComments res", res, "uniqueComments", uniqueComments);
      setCommentsList(uniqueComments);
    } catch (err) {
      console.log("fetchCalendarEventComments err", err);
    }
  };

  useEffect(() => {
    //console.log("selectedTrackerCalendarEvent", selectedTrackerCalendarEvent);
    if (selectedTrackerCalendarEventDisplay) {
      fetchCalendarEventComments();
    }
  }, []);

  const formRef = useRef(null);
  const {
    AlertDialog: ConfirmDialog,
    showDialog,
    closeDialog,
  } = useDialog({
    onSubmit: deleteComments,
    onClose: closeConfirm,
  });

  return (
    <Fragment>
      <Accordion
        disableGutters
        elevation={0}
        square
        onChange={handleChange}
        sx={{
          borderRadius: "12px",
          overflow: "hidden",

          border: "none", // ❌ remove full border
          borderBottom: "1px solid #e0e0e0", // ✅ only bottom border

          "&:before": {
            display: "none", // remove default MUI divider
          },
        }}>
        <AccordionSummary
          expandIcon={
            <div
              style={{
                width: 32,
                height: 32,
                borderRadius: "50%",
                backgroundColor: primaryColor,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                color: "#fff",
                fontSize: "18px",
              }}
            >
              {expanded ? "−" : "+"}
            </div>
          }
          sx={{
            backgroundColor: "#f5f6fa",
            minHeight: "56px",
            padding: "0 16px",
            "& .MuiAccordionSummary-content": {
              margin: 0,
            },
          }}
        >
          <Typography
            style={{
              fontSize: "0.9rem",
              fontWeight: "bold",
            }}
          >
            Comments
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Stack direction="column">
            <div>
              <TrackNowTextField
                id="comments"
                name="comments"
                multiline
                fullWidth
                minRows={2}
                placeholder="Add Comments..."
                value={approvalComment}
                onChange={(e) => {
                  if (e.target.value.length <= 256) {
                    onCommentChange(e);
                    setRemainingChars(256 - e.target.value.length);
                  }
                }}
              />
              <Typography
                sx={{
                  fontSize: "11px",
                  fontWeight: "small",
                  color: remainingChars === 0 ? "red" : "inherit",
                  display: remainingChars === 256 ? "none" : "block",
                }}
              >
                {remainingChars} Characters are left
              </Typography>
            </div>
            <div style={{ display: "flex" }}>

              {actionType === "Edit" ? (
                selectedComment &&
                selectedComment?.attachmentPath &&
                selectedComment.attachmentPath !== "undefined" && (
                  <MuiButton
                    size="small"
                    variant="text"
                    style={{ fontSize: "0.8rem" }}
                    onClick={() => downloadFile(selectedComment)}
                  >
                    {selectedComment?.attachmentPath && (
                      <GoogleMaterialIcon name="attach_file" fontSize="1rem" />
                    )}
                    <Tooltip
                      title={getFilenameToolip(selectedComment.attachmentPath)}
                    >
                      <ListItemText
                        primary={
                          selectedComment &&
                          selectedComment?.attachmentPath &&
                          getFilename(selectedComment.attachmentPath)
                        }
                      />
                    </Tooltip>
                  </MuiButton>
                )
              ) : (
                <form
                  method="post"
                  id="uploadForm"
                  onChange={(event) => onFileChange(event)}
                  style={{ margin: "1rem" }}
                // ref={formRef}
                >
                  <div className='field'>
                    <label className="file-upload">
                      <TrackNowTextField
                        type='file'
                        name='file'
                        id='inFile'
                      //  disabled={!draftSubmitted}
                      />
                    </label>
                  </div>
                </form>
              )}
            </div>
            <div>
              <div
                style={{
                  margin: "1rem",
                  display: "flex",
                  justifyContent: "flex-end",
                }}
              >
                <TrackNowButton
                  size="small"
                  variant="tertiary"
                  disabled={isLoading}
                  onClick={() => handleCancel()}
                >
                  Clear
                </TrackNowButton>
                {actionType === "Add" ? (
                  <TrackNowButton
                    size="small"
                    variant="primary"
                    type="submit"
                    disabled={isLoading}
                    onClick={() => handleAddComment()}
                  >
                    Add
                  </TrackNowButton>
                ) : (
                  <TrackNowButton
                    size="small"
                    variant="primary"
                    type="submit"
                    disabled={
                      isLoading ||
                      selectedComment?.commentsText?.trim() ===
                      approvalComment?.trim()
                    }
                    onClick={() => editComment()}
                  >
                    Edit
                  </TrackNowButton>
                )}
              </div>
              <div>
                {showError && <Alert severity="error">{alertMessage}</Alert>}
                {showSuccess && <Alert severity="success">{alertMessage}</Alert>}
              </div>
            </div>
          </Stack>
          <Divider />
          <DataTable
            size="small"
            scrollable
            scrollHeight="200px"
            value={commentsList}
            dataKey="commentsId"
            style={{ fontSize: "0.8rem" }}
          >
            <Column
              field="createUser"
              header="Created By"
              body={(rowData) => getUserName(rowData.createUser)}
            ></Column>
            <Column
              field="createDate"
              header="Created Date"
              body={(rowData) =>
                toLocalDateTime && toLocalDateTime(rowData.createDate)
              }
            ></Column>
            <Column field="commentsText" header="Comment"></Column>
            <Column
              field="attachmentPath"
              header="Attachment"
              body={renderAttachment}
            ></Column>
            <Column
              header="Action"
              style={{ textAlign: "center" }}
              body={(rowData) => (
                <>
                  <Stack direction="row">
                    <IconButton
                      aria-label="edit"
                      size="small"
                      onClick={() => handleEditComment(rowData)}
                    >
                      <Edit />
                    </IconButton>
                    <IconButton
                      aria-label="delete"
                      size="small"
                      onClick={() => handleDeleteComment(rowData)}
                    >
                      <Delete />
                    </IconButton>
                  </Stack>
                </>
              )}
            ></Column>
          </DataTable>
        </AccordionDetails>
        {<ConfirmDialog />}
      </Accordion>
    </Fragment>
  );
};

export default CalendarDetailsComments;
